import styled from "@emotion/styled/macro";
import { Banner, BannerTypes, Button } from "@sunrun/experience-ui-components";
import { getMissingContactInfoMessage } from "utils/contactValidation";

type MissingContactInfoBannerProps = {
  phone?: string;
  email?: string;
  onEdit: () => void;
  editTestId?: string;
};

const MissingContactInfoBanner = ({
  phone,
  email,
  onEdit,
  editTestId = "missing-contact-info-edit",
}: MissingContactInfoBannerProps) => {
  const message = getMissingContactInfoMessage(phone, email);

  if (!message) {
    return null;
  }

  return (
    <BannerContainer>
      <Banner
        bannerType={BannerTypes.ErrorLight}
        bannerTestId="missing-contact-info-banner"
        title={message}
        show={true}
        showClose={false}
        customButtons={
          <EditButton
            size="xs"
            color="tertiary"
            data-testid={editTestId}
            onClick={onEdit}
          >
            Edit
          </EditButton>
        }
      />
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 0 !important;
`;

const EditButton = styled(Button)`
  text-decoration: underline;
`;

export { MissingContactInfoBanner };
export type { MissingContactInfoBannerProps };
